/* Track Your Order page (sections/daftboy-tracking.liquid).
   Fetches the order view from the daftboy-tracking API and renders the order
   summary, Delivery Protection badge or add-protection offer, each shipment's
   journey, map and scan history, the items, and recommendations. */
(function () {
  var root = document.getElementById('db-track');
  if (!root) return;
  var API = (root.dataset.endpoint || '').replace(/\/+$/, '');
  var form = root.querySelector('[data-track-form]');
  var errorEl = root.querySelector('[data-track-error]');
  var result = root.querySelector('[data-track-result]');
  var PREP_TYPES = (root.dataset.productionTypes || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  var DAY = 86400000;
  var STEP_LABELS = { ORDERED: 'Ordered', PREP: 'Getting packed', LABEL: 'Label created', IN_TRANSIT: 'In transit', OUT_FOR_DELIVERY: 'Out for delivery', DELIVERED: 'Delivered' };
  var STATUS_TEXT = {
    LABEL_PRINTED: 'Label created', LABEL_PURCHASED: 'Label created', CONFIRMED: 'Label created', CARRIER_PICKED_UP: 'Picked up by the carrier',
    IN_TRANSIT: 'In transit', OUT_FOR_DELIVERY: 'Out for delivery', ATTEMPTED_DELIVERY: 'Delivery attempted', DELIVERED: 'Delivered',
    DELAYED: 'Delayed', FAILURE: 'Delivery problem', READY_FOR_PICKUP: 'Ready for pickup'
  };
  var SHIELD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>';

  var SHIELD_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3z"/><path d="M9.5 9.5l5 5M14.5 9.5l-5 5"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function day(iso) { return iso ? new Date(iso).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }) : ''; }
  function when(iso) { return iso ? new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : ''; }
  function place(e) { return [e.city, e.state, e.country].filter(Boolean).join(', '); }
  function money(n) { return '$' + Number(n).toFixed(2); }
  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = !msg; }

  function load(url, opts) {
    result.hidden = true;
    showError('');
    return fetch(url, opts).then(function (r) {
      if (r.status === 404) throw new Error("We couldn't find that order. Check the email and number, or contact us and we'll help.");
      if (r.status === 429) throw new Error('Too many tries. Please wait a few minutes and try again.');
      if (!r.ok) throw new Error('Tracking is having trouble right now. Please try again shortly.');
      return r.json();
    }).then(render).catch(function (e) { showError(e.message); });
  }

  // Ordered -> In production (made-to-order types) or Getting packed -> Label
  // created... The second step starts one day after the order is placed.
  var prepLabel = STEP_LABELS.PREP;
  function stepsHtml(stage) {
    var keys = ['ORDERED', 'PREP', 'LABEL', 'IN_TRANSIT', 'OUT_FOR_DELIVERY', 'DELIVERED'];
    var at = keys.indexOf(stage);
    return '<ol class="db-track__steps">' + keys.map(function (k, i) {
      return '<li class="' + (i <= at ? 'is-done' : '') + (i === at ? ' is-current' : '') + '">' + (k === 'PREP' ? prepLabel : STEP_LABELS[k]) + '</li>';
    }).join('') + '</ol>';
  }

  function shipmentHtml(s, i, total) {
    var title = total > 1 ? 'Shipment ' + (i + 1) + ' of ' + total : 'Your shipment';
    var latest = s.events[0];
    var head = '<div class="db-track__ship-head"><h3>' + title + '</h3><p>' +
      (s.carrier ? esc(s.carrier) + ' ' : '') +
      (s.trackingNumber ? (s.carrierUrl ? '<a href="' + esc(s.carrierUrl) + '" target="_blank" rel="noopener">' + esc(s.trackingNumber) + '</a>' : esc(s.trackingNumber)) : '') +
      '</p></div>';
    var eta = s.deliveredAt ? 'Delivered ' + day(s.deliveredAt)
      : s.estimatedDeliveryAt ? 'Estimated delivery ' + day(s.estimatedDeliveryAt)
      : 'Shipped ' + day(s.shippedAt);
    var alert = s.exception && latest ? '<p class="db-track__alert">' + esc(STATUS_TEXT[latest.status] || 'Update') + ': ' + esc(latest.message || 'The carrier reported an issue with this package.') + '</p>' : '';
    var events = s.events.map(function (e, n) {
      return '<li class="' + (e.exception ? 'is-exception' : '') + '"' + (n > 4 ? ' hidden' : '') + '><strong>' + esc(e.message || STATUS_TEXT[e.status] || e.status) + '</strong><span>' +
        esc([when(e.at), place(e)].filter(Boolean).join(' · ')) + '</span></li>';
    }).join('');
    var more = s.events.length > 5 ? '<button type="button" class="db-track__more" data-more>Show all ' + s.events.length + ' updates</button>' : '';
    return '<div class="db-track__box" data-shipment="' + i + '">' + head + '<p class="db-track__eta">' + eta + '</p>' + alert + stepsHtml(s.stage) +
      '<div class="db-track__map" data-map hidden></div>' +
      (events ? '<ul class="db-track__events">' + events + '</ul>' + more : '<p>The carrier hasn\'t scanned this package yet. Updates usually appear within a day of shipping.</p>') +
      '</div>';
  }

  function render(v) {
    var unshipped = !v.shipments.length;
    var made = v.items.some(function (it) { return it.type && PREP_TYPES.indexOf(it.type.toLowerCase()) > -1; });
    prepLabel = made ? 'In production' : 'Getting packed';
    var prepStarted = Date.now() - new Date(v.placedAt).getTime() >= DAY;
    var contact = esc(root.dataset.contactUrl), info = esc(root.dataset.protectionUrl);
    var logo = root.dataset.protectionLogo ? '<img class="db-track__cover-logo" src="' + esc(root.dataset.protectionLogo) + '" alt="" width="72" height="72">' : SHIELD;
    var coverage = '';
    if (v.protected) {
      coverage = '<div class="db-track__cover is-covered">' + logo + '<div><strong>Your package is covered with Shipping Protection</strong>' +
        '<p>If it\'s lost, stolen or damaged in transit, we\'ll make it right. <a href="' + info + '">What\'s covered</a></p></div></div>';
    } else if (!v.cancelled) {
      var a = v.addProtection, body, icon = a ? logo : SHIELD_OFF;
      if (a) {
        var href = '/cart/' + encodeURIComponent(a.variantId) + ':1?' + encodeURIComponent('attributes[' + a.attribute + ']') + '=' + encodeURIComponent(v.order.toUpperCase());
        body = '<p>Your order hasn\'t shipped yet, so you can still add this optional coverage. It covers your order if it is lost, stolen or damaged in transit. Shipping Protection can\'t be added once your order ships. <a href="' + info + '">What\'s covered</a></p>' +
          '<a class="button accent" href="' + href + '"><span>Add protection for ' + money(a.price) + '</span></a>';
      } else if (!unshipped) {
        body = '<p>Coverage can\'t be added once an order ships. If anything goes wrong with your delivery, <a href="' + contact + '">contact us</a> and we\'ll see how we can help.</p>';
      } else {
        body = '<p>If you have any issues with your order, <a href="' + contact + '">contact us</a> and we\'ll see how we can help.</p>';
      }
      var title = a ? 'Your package is not covered with Shipping Protection' : 'This order IS NOT Covered with Shipping Protection.';
      coverage = '<div class="db-track__cover is-not-covered">' + icon + '<div><strong>' + title + '</strong>' + body + '</div></div>';
    }
    var html = '<div class="db-track__box db-track__order"><div><h2>Order ' + esc(v.order.toUpperCase()) + '</h2><p>Placed ' + day(v.placedAt) +
      (v.cancelled ? ' · Cancelled' : '') + '</p></div>' + coverage + '</div>';

    if (v.items.length) {
      html += '<div class="db-track__box"><h3>In this order</h3><div class="db-track__items">' + v.items.map(function (it) {
        return '<div class="db-track__item">' + (it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy">' : '') +
          '<p><strong>' + esc(it.title) + '</strong>' + (it.variant ? '<br>' + esc(it.variant) : '') + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</p></div>';
      }).join('') + '</div></div>';
    }

    if (unshipped && !v.cancelled) {
      var headline = !prepStarted ? 'We got your order' : made ? 'Your order is in production' : 'We\'re packing your order';
      html += '<div class="db-track__box"><p class="db-track__eta">' + headline + '</p>' + stepsHtml(prepStarted ? 'PREP' : 'ORDERED') +
        '<p>You\'ll get an email with tracking as soon as it ships.</p></div>';
    }
    v.shipments.forEach(function (s, i) { html += shipmentHtml(s, i, v.shipments.length); });

    var actions = [];
    if (v.protected && v.shipments.length) actions.push('<a class="button accent" href="' + esc(root.dataset.reportUrl) + '#claim"><span>Report a delivery issue</span></a>');
    actions.push('<a class="button db-track__btn-pink" href="' + esc(root.dataset.contactUrl) + '"><span>Contact us</span></a>');
    actions.push('<a class="button db-track__btn-black" href="' + esc(root.dataset.trackPath || '/pages/track') + '"><span>Track a different order</span></a>');
    html += '<div class="db-track__actions">' + actions.join('') + '</div>';

    if (v.key && history.replaceState) {
      // Keep the order in the URL so a refresh or bookmark reopens it.
      var url = new URL(location.href);
      url.searchParams.set('order', v.order);
      url.searchParams.set('key', v.key);
      history.replaceState(null, '', url.toString());
    }
    result.innerHTML = html;
    result.hidden = false;
    // An order is showing: swap the "enter your email" intro for a status line.
    var lede = root.querySelector('[data-track-lede]');
    if (lede && root.dataset.introLoaded) lede.textContent = root.dataset.introLoaded;

    result.querySelectorAll('[data-more]').forEach(function (b) {
      b.addEventListener('click', function () { b.parentNode.querySelectorAll('.db-track__events li[hidden]').forEach(function (li) { li.hidden = false; }); b.remove(); });
    });
    v.shipments.forEach(function (s, i) { drawMap(s, result.querySelector('[data-shipment="' + i + '"] [data-map]')); });
    recommend(v.items);
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  var leaflet;
  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    return leaflet || (leaflet = new Promise(function (ok, fail) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
      s.onload = function () { ok(window.L); }; s.onerror = fail;
      document.head.appendChild(s);
    }));
  }

  function drawMap(s, el) {
    var stops = [];
    s.events.slice().reverse().forEach(function (e) { var p = place(e); if (p && stops[stops.length - 1] !== p) stops.push(p); });
    if (!stops.length || !el) return;
    var unique = stops.filter(function (p, i) { return stops.indexOf(p) === i; }).slice(-15);
    fetch(API + '/geo', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ places: unique }) })
      .then(function (r) { return r.ok ? r.json() : { points: {} }; })
      .then(function (d) {
        var pts = stops.map(function (p) { return d.points[p]; }).filter(Boolean);
        if (!pts.length) return;
        return loadLeaflet().then(function (L) {
          el.hidden = false;
          var map = L.map(el, { scrollWheelZoom: false, attributionControl: true });
          map.attributionControl.setPrefix(false); // OpenStreetMap's credit stays (license requires it); Leaflet's logo goes
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 12, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
          if (pts.length > 1) L.polyline(pts, { color: '#f91362', weight: 3, opacity: 0.8, dashArray: '6 6' }).addTo(map);
          pts.forEach(function (p, i) {
            var last = i === pts.length - 1;
            L.circleMarker(p, { radius: last ? 9 : 5, color: last ? '#f91362' : '#ff7e00', fillColor: last ? '#f91362' : '#ffcc00', fillOpacity: 1, weight: 2 }).addTo(map);
          });
          if (pts.length > 1) map.fitBounds(pts, { padding: [30, 30] }); else map.setView(pts[0], 8);
        });
      }).catch(function () {});
  }

  function recommend(items) {
    var box = root.querySelector('[data-track-recs]');
    var grid = root.querySelector('[data-track-recs-grid]');
    var first = items.filter(function (it) { return it.productId; })[0];
    if (!first) return;
    var mine = items.map(function (it) { return it.handle; });
    fetch('/recommendations/products.json?limit=8&product_id=' + encodeURIComponent(first.productId))
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = (d.products || []).filter(function (p) { return p.handle !== 'shipping-protection' && mine.indexOf(p.handle) === -1; }).slice(0, 4);
        if (!list.length) return;
        grid.innerHTML = list.map(function (p) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
          return '<a class="db-track__rec" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '<p><strong>' + esc(p.title) + '</strong></p><p>' + money(p.price / 100) + '</p></a>';
        }).join('');
        box.hidden = false;
      }).catch(function () {});
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = form.email.value.trim(), ref = form.ref.value.trim();
    if (!email || !ref) return showError('Please enter your email and your order or tracking number.');
    var btn = form.querySelector('button'); btn.disabled = true;
    load(API + '/track/lookup', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, ref: ref }) })
      .then(function () { btn.disabled = false; });
  });

  var q = new URLSearchParams(location.search);
  // Old AfterShip links we couldn't match land here with the tracking number filled in.
  var oldTracking = q.get('tracking') || q.get('tracking-number') || q.get('tracking_number');
  if (oldTracking) form.ref.value = oldTracking;
  // Links that carry only the order number (e.g. from the order status page) prefill it.
  if (!oldTracking && q.get('order') && !q.get('key')) form.ref.value = q.get('order').toUpperCase();
  if (q.get('order') && q.get('key')) {
    form.hidden = true;
    load(API + '/track?order=' + encodeURIComponent(q.get('order')) + '&key=' + encodeURIComponent(q.get('key'))).then(function () {
      if (result.hidden) form.hidden = false;
    });
  }
})();
